export const SettingsEndpoints = {
  GET_SETTING_BY_KEYNAME: '/api/admin/setting/bymetaname/:keyname',
  UPDATE_SETTING_VALUE: '/api/admin/setting/updatemetavalue',
};
